import gql from 'graphql-tag';
import { query } from '../../client';
import { PRODUCT_FIELDS } from '../fragments/productFields';
import { INVENTORY_FIELDS } from '../fragments/inventoryFields';
export const GET_PRODUCTS = gql `
  ${PRODUCT_FIELDS}
  ${INVENTORY_FIELDS}

  query ProductsQuery {
    products @rest(type: "ProductsResult", path: "products") {
      total
      data @type(name: "Product") {
        ...ProductFields
        inventories @type(name: "Inventory") {
          ...InventoryFields
        }
      }
    }
  }
`;
// Query products from OMNI.
export function getProducts() {
    return query({ query: GET_PRODUCTS });
}
export default getProducts;
